export const SIDEBAR_SELECT_ROUTE = 'SIDEBAR_SELECT_ROUTE';
export const HIDE_SIDE_BAR_CHANGE = 'HIDE_SIDE_BAR_CHANGE';
export const TOGGLE_NEW_SERVICE_WORK = 'TOGGLE_NEW_SERVICE_WORK';
